var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 1L6 6L11 1","stroke":"white","stroke-opacity":_vm.props.opacity,"stroke-width":"1.8"}})])}
var staticRenderFns = []

export { render, staticRenderFns }